// 项目管理模块配置
export const projectsConfig = {
  // 模块基本信息
  name: '项目管理',
  description: '计划、执行、监控',
  icon: 'ProjectOutlined',
  bgColor: '#52C41A',
  iconColor: '#FFFFFF',
  
  // API 端点
  apiEndpoints: {
    projects: '/projects',
    create: '/projects',
    update: '/projects',
    delete: '/projects',
    progress: '/projects/progress',
    addProgress: '/projects/add-progress',
    deleteProgress: '/projects/delete-progress'
  },
  
  // 项目状态
  projectStatus: [
    { value: 'planning', label: '规划中', color: '#1890FF', description: '项目正在规划阶段' },
    { value: 'executing', label: '执行中', color: '#52C41A', description: '项目正在执行阶段' },
    { value: 'monitoring', label: '监控中', color: '#FAAD14', description: '项目正在监控阶段' },
    { value: 'completed', label: '已完成', color: '#52C41A', description: '项目已完成' },
    { value: 'paused', label: '已暂停', color: '#FF4D4F', description: '项目暂时停止' },
    { value: 'cancelled', label: '已取消', color: '#666666', description: '项目已取消' }
  ],
  
  // 项目类型
  projectTypes: [
    '软件开发', '产品设计', '市场推广', '基础设施建设', '研发项目', '运营项目', '培训项目', '其他'
  ],
  
  // 风险程度
  riskLevels: [
    { value: 'low', label: '低风险', color: '#52C41A', description: '风险较低，可控' },
    { value: 'medium', label: '中风险', color: '#FAAD14', description: '风险中等，需要关注' },
    { value: 'high', label: '高风险', color: '#FF4D4F', description: '风险较高，需要重点监控' }
  ],
  
  // 人员规模
  teamSizes: [
    '1-5人', '6-10人', '11-20人', '21-50人', '51-100人', '100人以上'
  ],
  
  // 项目管理五大流程
  projectManagementProcess: {
    title: '项目管理的五大流程（PMBOK标准）',
    sections: [
      {
        title: '① 启动（Initiation）',
        subtitle: '明确目标、范围，立项',
        items: [
          '明确项目目标和范围',
          '确定项目经理和团队',
          '制定项目章程',
          '识别项目干系人',
          '进行可行性分析'
        ]
      },
      {
        title: '② 规划（Planning）',
        subtitle: '制定项目计划：任务分解、时间表、资源分配、风险预案',
        items: [
          '制定项目计划：任务分解（WBS）、时间表（Gantt）、资源分配、风险预案',
          '确定项目范围和工作分解结构（WBS）',
          '制定项目进度计划和时间表',
          '进行资源规划和成本估算',
          '制定风险管理计划',
          '制定质量管理计划',
          '制定沟通管理计划'
        ]
      },
      {
        title: '③ 执行（Execution）',
        subtitle: '团队分工，落实任务',
        items: [
          '团队分工，落实任务',
          '开展沟通协调，解决问题',
          '执行项目计划',
          '管理项目团队',
          '实施质量保证',
          '管理项目干系人',
          '执行采购活动'
        ]
      },
      {
        title: '④ 监控（Monitoring & Controlling）',
        subtitle: '跟踪进度、质量、成本',
        items: [
          '跟踪进度、质量、成本',
          '调整偏差，控制风险',
          '监控项目绩效',
          '控制项目变更',
          '管理项目风险',
          '控制项目质量',
          '管理项目沟通',
          '控制项目成本'
        ]
      },
      {
        title: '⑤ 收尾（Closing）',
        subtitle: '验收成果，总结复盘',
        items: [
          '验收成果，总结复盘',
          '归档文档，解散团队',
          '完成项目交付',
          '进行项目验收',
          '总结项目经验',
          '归档项目文档',
          '释放项目资源',
          '解散项目团队'
        ]
      }
    ],
    summary: '🌟 一句话总结：项目管理 = 目标清晰 + 计划合理 + 执行有序 + 风险可控 + 复盘优化'
  },
  
  // 项目管理方法论
  projectMethodologies: {
    title: '项目管理的常用方法论',
    sections: [
      {
        title: '传统瀑布模型',
        subtitle: '适合流程清晰、需求稳定的项目',
        items: [
          '适合流程清晰、需求稳定的项目（如建筑、硬件开发）',
          '线性开发流程：需求分析 → 设计 → 开发 → 测试 → 部署',
          '每个阶段完成后才能进入下一阶段',
          '变更成本较高，适合需求稳定的项目',
          '文档驱动，重视计划和文档'
        ]
      },
      {
        title: '敏捷管理（Agile/Scrum/Kanban）',
        subtitle: '适合需求变化快的软件开发',
        items: [
          '适合需求变化快的软件开发，迭代交付',
          '迭代开发：短周期迭代，快速交付',
          'Scrum：角色（PO、SM、Dev Team）、事件（Sprint、Daily Standup）、工件（Product Backlog、Sprint Backlog）',
          'Kanban：可视化工作流，限制在制品数量',
          '持续改进：回顾会议，不断优化流程',
          '用户故事：以用户价值为导向的需求描述'
        ]
      },
      {
        title: 'OKR/KPI 管理',
        subtitle: '目标驱动，常用于企业战略项目',
        items: [
          '目标驱动，常用于企业战略项目',
          'OKR（Objectives and Key Results）：目标与关键结果',
          'KPI（Key Performance Indicators）：关键绩效指标',
          '目标设定：SMART原则（具体、可衡量、可实现、相关性、时限性）',
          '定期回顾：季度或月度回顾和调整',
          '透明沟通：全员可见，促进协作'
        ]
      }
    ]
  },
  
  // 实际管理要点
  managementTips: {
    title: '实际管理要点',
    sections: [
      {
        title: '明确目标',
        items: [
          '项目要做什么，不做什么',
          '设定清晰的项目目标和成功标准',
          '明确项目范围和边界',
          '确保所有干系人对目标的理解一致',
          '定期回顾和调整目标'
        ]
      },
      {
        title: '分解任务',
        items: [
          '大目标拆小任务，每个人知道自己干什么',
          '使用工作分解结构（WBS）',
          '任务粒度适中，便于跟踪和管理',
          '明确任务负责人和完成时间',
          '建立任务依赖关系'
        ]
      },
      {
        title: '时间管理',
        items: [
          '用甘特图、看板来跟踪',
          '制定详细的项目时间表',
          '识别关键路径和里程碑',
          '定期更新进度状态',
          '及时调整计划应对变化'
        ]
      },
      {
        title: '沟通机制',
        items: [
          '例会、日报、周报，确保信息透明',
          '建立定期沟通机制（日站会、周例会、月回顾）',
          '选择合适的沟通工具和渠道',
          '确保信息及时、准确传递',
          '建立问题升级机制'
        ]
      },
      {
        title: '风险管理',
        items: [
          '提前想"最坏的可能"，准备B计划',
          '识别项目风险并评估影响',
          '制定风险应对策略',
          '建立风险监控机制',
          '定期回顾和更新风险清单'
        ]
      },
      {
        title: '复盘总结',
        items: [
          '失败和成功都要记录，为下次项目提供经验',
          '项目结束后进行总结复盘',
          '记录项目经验和教训',
          '分享最佳实践',
          '持续改进项目管理流程'
        ]
      }
    ]
  },
  
  // 项目管理工具
  projectTools: {
    title: '项目管理工具推荐',
    sections: [
      {
        title: '项目管理平台',
        items: [
          'Jira：敏捷项目管理，适合软件开发',
          'Trello：看板管理，简单易用',
          'Asana：任务管理，团队协作',
          'Monday.com：可视化项目管理',
          'Microsoft Project：传统项目管理，甘特图'
        ]
      },
      {
        title: '协作工具',
        items: [
          'Slack：团队沟通协作',
          'Microsoft Teams：企业级协作平台',
          '钉钉：国内企业协作工具',
          '飞书：字节跳动协作平台',
          'Zoom：视频会议工具'
        ]
      },
      {
        title: '文档管理',
        items: [
          'Confluence：知识管理和文档协作',
          'Notion：全能型协作平台',
          '语雀：阿里系知识管理平台',
          '腾讯文档：在线文档协作',
          '石墨文档：国内在线文档工具'
        ]
      },
      {
        title: '设计工具',
        items: [
          'Figma：UI/UX设计协作',
          'Sketch：Mac平台设计工具',
          'Adobe XD：用户体验设计',
          'Axure RP：原型设计工具',
          '墨刀：国内原型设计工具'
        ]
      }
    ]
  },
  
  // 项目进度记录模板
  progressTemplates: [
    {
      title: '项目启动',
      content: '项目{projectName}正式启动，目标{goal}，预计{timeline}完成。'
    },
    {
      title: '里程碑达成',
      content: '完成{里程碑}，进度{progress}%，{achievements}，下一步{nextSteps}。'
    },
    {
      title: '问题解决',
      content: '遇到{problem}，通过{solution}解决，影响{impact}，经验{lessons}。'
    },
    {
      title: '风险控制',
      content: '识别风险{risk}，影响程度{level}，应对措施{measures}，监控状态{status}。'
    },
    {
      title: '项目总结',
      content: '项目{projectName}完成，成果{results}，成本{cost}，经验{experience}。'
    }
  ],
  
  // 项目评估指标
  evaluationMetrics: {
    title: '项目评估指标',
    sections: [
      {
        title: '进度指标',
        items: [
          '计划完成率：实际进度 vs 计划进度',
          '里程碑达成率：关键节点完成情况',
          '任务完成率：各阶段任务完成情况',
          '延期情况：项目延期天数和原因'
        ]
      },
      {
        title: '质量指标',
        items: [
          '缺陷率：项目交付物的缺陷数量',
          '客户满意度：干系人对项目结果的满意度',
          '返工率：因质量问题导致的返工工作量',
          '验收通过率：项目交付物的验收情况'
        ]
      },
      {
        title: '成本指标',
        items: [
          '预算执行率：实际成本 vs 预算成本',
          '成本偏差：计划成本与实际成本的差异',
          '资源利用率：人力资源和物资的利用效率',
          '投资回报率：项目收益与投入的比率'
        ]
      },
      {
        title: '风险指标',
        items: [
          '风险识别率：已识别风险占总风险的比例',
          '风险应对率：已制定应对措施的风险比例',
          '风险发生频率：项目期间风险事件的发生次数',
          '风险影响程度：风险事件对项目的影响大小'
        ]
      }
    ]
  }
};
